export const ReportsTypes = {
  SHOW_RESIDENT_DEBTS: "SHOW_RESIDENT_DEBTS",
};
